export class Visit {
  id: number;
  enter: string;
  leave: string;
  visitorId: number;
  visitorName: string;
  visitorBirthDay: string;
  phone: string;
  email: string;
  roomId: number;
  roomName: string;
  status: number;
  cardType: number;
  hours: number;
  phoneVisit: string;
  emailVisit: string;
  cardId:number;
  imageQr: string;
  surcharge: boolean;
  surchargeHours: number;
  gratis:boolean;
  parentId?: number;
  constructor() {
    this.id = null;
    this.enter = '';
    this.leave = '';
    this.visitorName = '';
    this.visitorBirthDay ='';
    this.visitorId = null;
    this.phone= '';
    this.email= '';
    this.roomId = null;
    this.roomName = '';
    this.status = null;
    this.hours = null;
    this.phoneVisit='';
    this.emailVisit='';
    this.cardId=null;
    this.imageQr;
    this.surcharge = false;
    this.surchargeHours = 0;
    this.gratis=false;
  }
}
